import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"margin-top":"-80px"} }
const _hoisted_2 = {
  key: 0,
  class: "donation-amount-bar"
}
const _hoisted_3 = { class: "amount-info-box" }
const _hoisted_4 = { class: "amount-info-box" }
const _hoisted_5 = { class: "donation-box-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.show_collection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, [
              _createElementVNode("span", null, _toDisplayString($props.symbol), 1 /* TEXT */),
              _createTextVNode(_toDisplayString($props.needed), 1 /* TEXT */)
            ]),
            _createElementVNode("span", null, _toDisplayString($props.strings ? $props.strings.target : 'Target Neeeded'), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", null, [
              _createElementVNode("span", null, _toDisplayString($props.symbol), 1 /* TEXT */),
              _createTextVNode(_toDisplayString($props.collected), 1 /* TEXT */)
            ]),
            _createElementVNode("span", null, _toDisplayString($props.strings ? $props.strings.collection : 'Collected'), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, _toDisplayString($props.tagline), 1 /* TEXT */),
      _createElementVNode("h2", null, _toDisplayString($props.title), 1 /* TEXT */)
    ])
  ]))
}